import InputText from '@Components/Fields/InputText'
import Dropdown from '@Components/Selectors/Dropdown'
import RoleTooltip from '@Components/WorkRegistrationSubs/AddWriter/WriterCreateForm/RoleTooltip'
import Button from '@Components/Buttons/Button'
import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { SelectOption } from '@Components/Selectors/Select'
import { WriterCreateFormValidations } from '@Components/WorkRegistrationSubs/AddWriter/WriterCreateForm'

interface WriterCreateSubFormProps {
    firstName: string | null
    lastName: string | null
    roleCode: number | null
    ipiNumber: string | null
    validations: WriterCreateFormValidations
    onClick: (val: boolean) => void
    getValues: (value: string | number | boolean | null, id: string) => void
    buttonsDisabled: boolean
}

const WriterCreateSubForm = ({
    firstName,
    lastName,
    roleCode,
    ipiNumber,
    validations,
    onClick,
    buttonsDisabled,
    getValues,
}: WriterCreateSubFormProps) => {
    const { libStore } = useContext(StoresContext)
    return (
        <div className="writer-sub-form-component">
            <InputText
                mainColor
                id="firstName"
                label="Writer First Name"
                value={firstName}
                errorMessage={validations.firstName.error}
                required={validations.firstName.required}
                onChange={getValues}
            />
            <InputText
                mainColor
                id="lastName"
                label="Writer Last Name"
                value={lastName}
                errorMessage={validations.lastName.error}
                required={validations.lastName.required}
                onChange={getValues}
            />
            <Dropdown
                options={libStore.writerRoles}
                label="Writer Role"
                mainColor
                selectedValue={roleCode ? libStore.writerRoles.find((option) => +option.id === roleCode) : null}
                onSelect={(option: SelectOption) => getValues(+option.id, 'roleCode')}
                isSearchable
                required
                errorMessage={roleCode ? undefined : 'Required'}
                tooltip={<RoleTooltip />}
            />
            {!roleCode && (
                <div className="writer-role-error-help">
                    Click{' '}
                    <a href="https://help.themlc.com/en/support/writer-roles" target="_blank" rel="noopener noreferrer">
                        here
                    </a>{' '}
                    for a list of writer roles and their definitions.
                </div>
            )}
            <InputText
                mainColor
                id="ipiNumber"
                label="IPI"
                value={ipiNumber}
                errorMessage={validations.ipiNumber.error}
                required={validations.ipiNumber.required}
                onChange={getValues}
            />

            <div className="writer-sub-form-footer">
                <Button mainColor type="secondary" onClick={() => onClick(false)} disabled={buttonsDisabled}>
                    Save & Add Another Writer
                </Button>
                <Button mainColor type="primary" onClick={() => onClick(true)} disabled={buttonsDisabled}>
                    Continue
                </Button>
            </div>
        </div>
    )
}

export default WriterCreateSubForm
